import inputFocusMixin from './inputFocusMixin'
import { getParents, isEmpty, isIos } from '../libs/helpTools'

export default {
  mixins: [inputFocusMixin],
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: [String, Number],
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [Number, String],
      default: '0'
    },
    small: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    forcedShowValue: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: Object,
      required: false
    },
    hasFilledHighlight: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: true
    },
    hasDescription: {
      type: Boolean,
      default: false
    },
    inputMode: String,
    maxLength: {
      type: Number,
      default: 190
    },
    skeletonLoading: {
      type: Boolean,
      default: false
    },

    autocomplete: Boolean,
    autocompleteEntityName: String,
    autocompleteSearchFieldName: String,
    autocompleteEmbed: String,
    autocompleteList: Array,
    autocompleteMinSearchFieldSize: Number,
    autocompleteMaxSearchFieldSize: Number,
    autocompleteIsSearchApi: Boolean,
    copy: Boolean
  },
  data () {
    return {
      isInteractiveChanged: false,
      isCanBlur: true,
      isAutocompleteLoading: false
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    hasLoading () {
      return this.loading || this.isAutocompleteLoading
    },
    hasValue () {
      return !isEmpty(this.innerValue) || this.forcedShowValue
    },
    showClearIcon () {
      return this.hasValue && this.clearable && !this.loading && !this.disabled
    },
    activeTabindex () {
      return this.disabled ? '-1' : this.tabindex
    },
    sizeClass () {
      return {
        'size-s': this.small
      }
    },
    containerClass () {
      return {
        disabled: this.disabled,
        small: this.small
      }
    },
    isShowAutocomplete () {
      return this.isInteractiveChanged && this.isFocus
    }
  },
  beforeDestroy () {
    this.unwatchWindowBlur()
    this.setIosKeyboardState(false)
  },
  methods: {
    onInput (e) {
      this.innerValue = e.target.value
      this.$emit('real-input', e)
      this.isInteractiveChanged = true
    },
    setIosKeyboardState (isOpen) {
      if (!isIos()) return
      if (isOpen) document.body.classList.add('_fl-style-has-ios-keyboard')
      else document.body.classList.remove('_fl-style-has-ios-keyboard')
    },
    focus () {
      if (this.disabled || this.isFocus) return
      this.setFocus(true)
      this.$nextTick(() => {
        this.$refs.input?.focus?.()
        this.watchWindowBlur()
      })
      this.setIosKeyboardState(true)
    },
    blur () {
      if (!this.isCanBlur) {
        this.$refs.input?.focus?.()
        return
      }

      this.setFocus(false)
      this.$refs.input?.blur()
      this.setIosKeyboardState(false)
      this.unwatchWindowBlur()
      this.isInteractiveChanged = false
    },
    onMouseDown (e) {
      const inputEl = this.$el
      const targetParents = getParents(e.target)
      if (!targetParents.includes(inputEl) && !e.target === inputEl) return
      this.isCanBlur = false
      document.addEventListener('mouseup', this.unlockBlur, { once: true })
    },
    unlockBlur () {
      this.isCanBlur = true
    },
    watchWindowBlur () {
      window.addEventListener('blur', this.hardBlur)
    },
    unwatchWindowBlur () {
      window.removeEventListener('blur', this.hardBlur)
    },
    hardBlur () {
      document.removeEventListener('mouseup', this.unlockBlur)
      this.isCanBlur = true
      this.blur()
      this.$refs.input?.blur?.()
    },
    clearValue () {
      this.innerValue = ''
      this.$emit('clear')
    },
    submit () {
      this.$emit('submit', this.innerValue)
    },
    setAutocompleteLoadingState (isLoading) {
      this.isAutocompleteLoading = isLoading
    },
    selectAutocomplete (item) {
      this.$emit('select-autocomplete', item)
      this.blur()
    },
    onCopyButtonClick (text) {
      this.$emit('copy', text)
    }
  }
}
